import { DefaultSelectionError as E } from "./atoms-v21279.js";
import { getCellTime as f } from "./atoms-v259.js";
import { getCellValue as D } from "./atoms-v260.js";
import { getDifferenceInDays as I } from "./atoms-v262.js";
function B(n, e, t) {
  var x, y;
  function S(i) {
    return i.filter((l) => {
      var a;
      return (a = l[1].cellData) == null ? void 0 : a.available;
    });
  }
  function s(i) {
    return S(i).length === i.length;
  }
  if (!n.size)
    return {
      isReady: !1
    };
  const r = Array.from(n.entries()), m = e, d = t, u = r.findIndex((i) => i[0] === m), c = r.findIndex((i) => i[0] === d);
  if (u === -1 || c === -1)
    return {
      isReady: !1
    };
  const b = ((x = r[u][1].cellData) == null ? void 0 : x.minSelection) ?? 1;
  if (c - u >= b) {
    const i = r.slice(
      u,
      c
    );
    if (s(i))
      return {
        isReady: !0,
        isValid: !0
      };
  }
  const o = r.slice(u);
  for (let i = 0; i < o.length; i++) {
    const l = ((y = o[i][1].cellData) == null ? void 0 : y.minSelection) ?? 1;
    if (!o[i + l])
      break;
    const a = o.slice(i, i + l);
    if (s(a))
      return {
        isReady: !0,
        isValid: !1,
        nextSelection: [
          D(o[i][1].cellUID),
          D(o[i + l][1].cellUID)
        ]
      };
  }
  return {
    error: E.NoContiguousAvailability,
    isReady: !0,
    isValid: !1
  };
}
function V(n, e) {
  return n ? e.indexOf(n) : -1;
}
function h(n, e) {
  var t;
  if (n)
    return (t = e.get(n)) == null ? void 0 : t.cellData;
}
function M(n, e) {
  var t;
  if (n)
    return (t = e.get(n)) == null ? void 0 : t.cellData;
}
function O(n, e, t) {
  if (!n)
    return null;
  if (t && e) {
    if (f(t) >= f(e))
      return t;
    if (f(e) > f(t))
      return e;
  }
  return t && f(t) >= f(n) ? t : e || n;
}
function U(n, e) {
  var t;
  if (n)
    return (t = e.get(n)) == null ? void 0 : t.cellData;
}
function v(n, e, t) {
  return n < 0 || !e ? [] : t.slice(
    n + 1,
    e != null && e.maxSelection ? n + 1 + e.maxSelection : void 0
  );
}
function W(n, e) {
  if (!n)
    return [];
  const t = e.indexOf(n);
  return t < 0 ? [] : e.slice(0, t);
}
function z(n, e, t) {
  return n || !e ? [] : t.slice(
    0,
    (t.indexOf(e) ?? 0) + 1
  );
}
function N(n, e, t) {
  return !e || !e.minSelection || e.minSelection === 1 ? [] : t.slice(n + 1, n + e.minSelection);
}
function T(n, e, t) {
  return !e || !e.maxSelection ? [] : t.slice(n + e.maxSelection);
}
function j(n, e, t, S) {
  if (!n)
    return null;
  const s = (e == null ? void 0 : e.minSelection) ?? 0, r = t.find((d) => {
    var c;
    const u = (c = S.get(d)) == null ? void 0 : c.cellData;
    return !!u && !u.available;
  });
  return r && I(r, n) >= s ? r : null;
}
export {
  T as getCellsDisabledByMaxSelectionBounds,
  N as getCellsDisabledByMinSelectionBounds,
  j as getCheckoutDateCell,
  z as getConsideredCells,
  O as getEndOfActiveRangeCell,
  U as getEndOfActiveRangeCellData,
  M as getEndingCellData,
  v as getIntegratedDataStoreActionableKeys,
  W as getSelectedCells,
  h as getStartingCellData,
  V as getStartingCellIdx,
  B as validateDefaultSelection
};
